import { Injectable } from '@angular/core';

@Injectable()
export class ChatService {

  constructor() { }

  /**
   * Inicializa el chat de Tawkto en la pantalla seleccionada
   */
  public mostrarChat(){
    // Código de Tawkto
    var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
    (function(){
    var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
    s1.async=true;
    s1.src='https://embed.tawk.to/5888b46f5dd96b5a9204a564/default';
    s1.charset='UTF-8';
    s1.setAttribute('crossorigin','*');
    s0.parentNode.insertBefore(s1,s0);
    })();
  }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/chat.service.ts